export const SEND_DATA = 'send-data'
export const SET_SELECTION_ONTO_MAP = 'set-selection-onto-map'
export const REMOVE_SELECTION_OFF_MAP = 'remove-selection-off-map'
